import React from 'react';
import { Helmet } from 'react-helmet';

/**
 * When updating eyeable script that is on `static/js` folder,
 * please update this version number to make sure cache is invalidated
 * on the clients browser.
 */
const version = '1.0.1';

export const EyeAble = (): JSX.Element => (<Helmet>
  <script
    async
    type="text/plain"
    className="optanon-category-C0003"
    src={`/js/eye-able.js?v=${version}`}></script>
</Helmet>);
